import React, { InputHTMLAttributes } from 'react';

import * as S from './styled';

type Mask = string[] | { (): void };

interface Props extends InputHTMLAttributes<HTMLInputElement> {
  type?: string;
  mask?: Mask;
  inputRef: React.RefObject<HTMLElement>;
}

const TextInput = ({
  mask,
  inputRef,
  ...rest
}: Props) => (mask ? (
  <S.Masked
    {...rest}
    ref={inputRef}
    mask={mask}
  />
) : (
  <S.Input
    ref={inputRef}
    {...rest}
  />
));

TextInput.defaultProps = {
  type: 'text',
  mask: null,
};

export default TextInput;
